export default {
  add_attachment: "Add Attachment",
  add_to_work_order: "Add to Work Order",
  associate_identifier: "Associate Identifier",
  change_requests: "Change Requests",
  clone_item: "Clone Item",
  close_issue: "Close Issue",
  create_item: "Create Item",
  create_location: "Create Location",
  create_model: "Create Model",
  create_work_order: "Create Work Order",
  close_work_order: "Close Work Order",
  delete: "Delete",
  discard: "Discard",
  discard_work: "Discard Work",
  export_results: "Export Results",
  feedback: "Feedback",
  handle_identifiers: "Handle Identifiers",
  help: "Help",
  history: "History",
  issues: "Issues",
  mark_all_read: "Mark All as Read",
  mark_all_unread: "Mark All as Unread",
  perform_adhoc_work: "Perform Ad-hoc Work",
  perform_corrective_work: "Perform Corrective Work",
  raise_issue: "Raise Issue",
  delete_issue: "Delete Issue",
  reject_issue: "Reject Issue",
  remove_from_work_order: "Remove from Work Order",
  remove_location: "Remove from Location",
  replace_item: "Replace Item",
  supersede_issue: "Supersede Issue",
  support: "Support",
  take_photo: "Take Photo",
  toggle_display_performed: "Toggle Display Performed",
  user_settings: "User Settings",
  image_zoom_in: "Zoom In",
  image_zoom_out: "Zoom Out",
}
